import React, { Component, Fragment } from 'react';
import InventoryHeader from './InventoryHeader';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { jwtDecode } from "jwt-decode";
import { getFromLocalStorage } from '../../services/utils';

@inject('InventoryStore')
@inject('UserStore')
@inject('StockTransferStoreItems')
@observer
class Inventory extends Component {
    componentDidMount = () => {
        const { UserStore, StockTransferStoreItems: { handleGetReceipts } } = this.props;
        const jwtToken = getFromLocalStorage('jwtToken');
        if (jwtToken) {
            try {
                const decodedToken = jwtDecode(jwtToken);
                UserStore.position = decodedToken.position;
            } catch (error) {
                console.error('Invalid JWT token:', error);
            }
        }
        //handleGetReceipts();
    };

    render() {
        const { UserStore, StockTransferStoreItems: { receipts } } = this.props;
        const { position } = UserStore;

        const handleStartStockCount = (e) => {
            // if (receipts && receipts.length > 0) {
            //     e.preventDefault();
            //     UserStore.message = 'All receipts must be completed before you can do Stock Count';
            // }
        };

        return (
            <Fragment>
                <InventoryHeader title="Stock Count" backLink="" />
                <div className="inventory-menu">
                    <h2>{moment().format('dddd - DD/MM/YYYY')}</h2>
                        {
                            position && (
                                <div className="btn-wrapper mm">
                                    <Link
                                        to={{
                                            pathname: `/inventory/stock-count/components/final`,
                                            state: { itemType: 'Component' },
                                        }}
                                        onClick={handleStartStockCount}
                                    >
                                        <button className="btn btn-primary width--300px">
                                            Start Stock Count
                                        </button>
                                    </Link>
                                </div>
                            )
                        }
                    <div className="btn-wrapper mm">
                        <Link
                            to={{
                                pathname: `/inventory/print-stock-count`,
                            }}
                        >
                            <button className="btn btn-primary width--300px">
                                Print Stock Count List
                            </button>
                        </Link>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Inventory;
